import { InfoRow } from "./InfoRow";
import { GetOpportunitiesDataResponse } from "@/pages/explorer/types";
import { TimeSavingsTag } from "@/modules/insights";

export const TimeSavingsInfo = ({ opportunity }: { opportunity: GetOpportunitiesDataResponse }) => {
  if (!opportunity.time_savings) {
    return null;
  }
  return (
    <InfoRow label="Time Savings" value={<TimeSavingsTag savings={opportunity.time_savings} />} />
  );
};
